module.exports = __webpack_public_path__ + "img/home-active.a0b178b1.svg";